.box {
}

.fullScreenDropInfo {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: hsl(180, 100%, 50%, 50%);
    backdrop-filter: blur(1em);
}
